import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { ManifestActions, OrderActions } from '../../../actions';
import Loader from '../../../components/Loader';
import SubnavBar from '../../../components/SubnavBar';
import TitleBar from '../../../components/TitleBar';
import ManifestList from '../../../components/Dispatcher/Manifests/List';

class Manifests extends Component {
  constructor(props) {
    super(props);
    this.onDelete = this.onDelete.bind(this);
  }
  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(ManifestActions.getAll())
    // dispatch(OrderActions.getAtFacility());
    dispatch(OrderActions.getOnDoc());
  }

  onNew = () => {
    browserHistory.push('/dispatcher/manifest')
  }

  onDelete(manifest) {
    this.props.dispatch(ManifestActions.deleteManifest(manifest)).then(() => {
      this.props.dispatch(ManifestActions.getAll());
    });
  }

  render() {
    const { manifests } = this.props;
    let content;

    if (!manifests || manifests.fetching === true || !manifests.list) {
      content = (<Loader />);
    } else {
      content = <ManifestList dataProvider={manifests.list} deleteManifest={this.onDelete} />
    }

    const subnavItems = [
      { key: 1, label: 'New', onClick: this.onNew },
    ];


    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} />
          <TitleBar title="Manifests" />
          <div className="row">
            <div className="col s12">
              {content}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    manifests: state.manifests
  };
}

export default connect(mapStateToProps)(Manifests);



// WEBPACK FOOTER //
// ./src/containers/Dispatcher/Manifests/index.js